/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ScrollMenu from 'react-horizontal-scrolling-menu';
import ContentItem from '../../components/ContentItemEnd';
import { isMobile } from 'react-device-detect';

class SameTimeContent extends Component {
  state = {
    menuIndex: 0,
    slideIndex: 1,
    slidePlay: true,
    mouseOn: false,
    onEvent: false,
    translate: 0,
  };
  _isMounted = false;
  componentDidMount = () => {
    const { refer } = this.props.childProps;
    this._isMounted = true;
    this._getContent(refer === 'sametime' ? '/sameTime' : '/popular');
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getContent = async (api) => {
    // const { loginId } = this.props;

    const result = await this._getContentApi(api);
    const intReturn = result.data[0].intReturn;
    const sameCode = result.data[0].sameCode;
    const contentList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          contentList,
          sameCode,
        });
      }
    }
  };
  _getContentApi = (api) => {
    const { apiUrl, loginId } = this.props;

    return axios(apiUrl + api + '?userid=' + loginId)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _renderItem = () => {
    const { contentList } = this.state;
    const { refer } = this.props.childProps;

    const list = contentList.map((item, index) => {
      return (
        <div key={index}>
          <ContentItem
            refer={refer}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            contentPartSerial={item.contentPartSerial}
            num={index + 1}
            onEndItemSlide={this._onEndItemSlide}
            subTitle={item.subTitle}
            cashOnly={item.cashOnly}
            weekTime={item.comment}
          />
        </div>
      );
    });

    return list;
  };
  _onEndItemSlide = (num, over) => {
    const { slideIndex } = this.state;
    let scrollPos;
    ////console.log(slideIndex)
    if (num === null || num === '' || num === undefined) {
    } else {
      //console.log(over, num, slideIndex)
      if (over) {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 1;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 7;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 13;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 19;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      } else {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 0;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 6;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 12;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 18;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      }
    }
  };

  _onToggleMouseOn = () => {
    // const { mouseOn, slideIndex, contentList } = this.state;

    this.setState({
      mouseOn: true,
    });

    /*
        this.setState({
            translate: -500
        })
        */
    ////console.log('===>')
    ////console.log(this.scrollMenu)
    //this.scrollMenu.scrollTo(10)
    ////console.log(slideIndex)
    ////console.log(parseInt(contentList.length/6))
  };
  _onToggleMouseOff = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: false,
    });
  };
  _onSelect = (key) => {
    ////console.log(key)
    ////console.log(0)
    //const a = 10
    //this.scrollMenu.scrollTo(a.toString())
  };
  _arrowNext = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    const page = Math.round(cnt / 6);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    // const cnt = contentList.length;
    // const page = Math.round(cnt / 6);

    //if(slideIndex <= 1) {
    this.setState({
      slideIndex: slideIndex - 1,
    });
    //}
  };
  _renderDot = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = parseInt(contentList.length);

    let page = Math.round(cnt / 6);
    if (page === 0) {
      page = 1;
    }

    let arr = [];

    for (let i = 1; i <= page; i++) {
      arr.push(<em key={i} className={i === slideIndex ? 'on' : null}></em>);
    }
    const list = arr.map((item) => {
      return item;
    });
    ////console.log()
    return list;
  };
  _onUpdate = (translate) => {
    ////console.log(translate)
  };
  _onMore = () => {
    const { sameCode } = this.state;
    const { history } = this.props;
    history.push('/list?q=same&c=' + sameCode);
  };
  render() {
    const { contentList, mouseOn, slideIndex, sameCode } = this.state;
    const { refer } = this.props.childProps;
    return (
      <Fragment>
        {contentList ? (
          <div className="main_list_style m_thumblist">
            <h1>
              {refer === 'sametime' ? (
                <strong>
                  {sameCode ? sameCode.toString().substr(0, 4) : null}.
                  {sameCode ? sameCode.toString().substr(4, 2) : null}{' '}
                  한일동시방영작
                </strong>
              ) : (
                <strong>주간 인기프로그램 TOP 10</strong>
              )}

              {/* <div>
                {this._renderDot()}
                <a style={{ cursor: 'pointer' }} onClick={this._onMore}>
                  더보기
                </a>
              </div> */}
            </h1>
            <div
              className="main_list_goup1"
              onMouseEnter={this._onToggleMouseOn}
              onMouseLeave={this._onToggleMouseOff}
            >
              {/*
                        <a href="#" className="left_btn"><span>이전</span></a>
                        <a href="#" className="right_btn"><span className="on">다음</span></a>
                        */}
              {/*리스트 오브 시 좌우 버튼 생김*/}
              <div className="div_ul">
                {/*
                        <Slider ref={(ref) => (this.slider = ref)} {...settings} >
                    
                            { contentList ? this._renderItem() : null}
                        
                        </Slider>
                        */}
                <ScrollMenu
                  data={contentList ? this._renderItem() : null}
                  arrowLeft={
                    isMobile ? null : (
                      <a
                        className="left_btn"
                        style={{ cursor: 'pointer' }}
                        onClick={this._arrowPrev}
                      >
                        <span className={'on'}>이전</span>
                      </a>
                    )
                  }
                  arrowRight={
                    isMobile ? null : (
                      <a
                        className="right_btn"
                        style={{ cursor: 'pointer' }}
                        onClick={this._arrowNext}
                      >
                        <span className={'on'}>다음</span>
                      </a>
                    )
                  }
                  wheel={false}
                  dragging={true}
                  //transition={0.5}
                  translate={2}
                  alignOnResize={true}
                  //inertiaScrolling={true}
                  //inertiaScrollingSlowdown={3}
                  //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                  itemStyle={{ verticalAlign: 'text-top' }}
                  alignCenter={false}
                  hideSingleArrow={true}
                  hideArrows={mouseOn}
                  onUpdate={this._onUpdate}
                  ref={(ref) => (this.scrollMenu = ref)}
                  //innerWrapperStyle={{textAlign: 'center'}}
                  onSelect={this._onSelect}
                  rtl={false}
                  scrollBy={6}
                  //selected={selected}
                />
              </div>
              <div className="clear"></div>
            </div>
          </div>
        ) : null}
        {/*
                <div>
                    { contentList ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(SameTimeContent));
